/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Table_Name_HeaderInputs */

const en_speakers_table_name_header = /** @type {(inputs: Speakers_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const fr_speakers_table_name_header = /** @type {(inputs: Speakers_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

const de_speakers_table_name_header = /** @type {(inputs: Speakers_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const it_speakers_table_name_header = /** @type {(inputs: Speakers_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

const ru_speakers_table_name_header = /** @type {(inputs: Speakers_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя`)
};

const es_speakers_table_name_header = /** @type {(inputs: Speakers_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre`)
};

const zh_cn2_speakers_table_name_header = /** @type {(inputs: Speakers_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

const ja_speakers_table_name_header = /** @type {(inputs: Speakers_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

const hi_speakers_table_name_header = /** @type {(inputs: Speakers_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम`)
};

const pt_pt2_speakers_table_name_header = /** @type {(inputs: Speakers_Table_Name_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Speakers_Table_Name_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_table_name_header = /** @type {((inputs?: Speakers_Table_Name_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Table_Name_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_table_name_header(inputs)
	if (locale === "de") return de_speakers_table_name_header(inputs)
	if (locale === "it") return it_speakers_table_name_header(inputs)
	if (locale === "ru") return ru_speakers_table_name_header(inputs)
	if (locale === "es") return es_speakers_table_name_header(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_table_name_header(inputs)
	if (locale === "ja") return ja_speakers_table_name_header(inputs)
	if (locale === "hi") return hi_speakers_table_name_header(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_table_name_header(inputs)
	return en_speakers_table_name_header(inputs)
});